define('frontend-common-components/objectStorageConfig/js/views/items/bucketSpecifyConfigurationView',[
        './base/baseItemView',
        'hbs!../../../templates/items/bucketSpecifyConfiguration',
        '../../helpers/awsHelper',
        '../../constants/events',
        'i18n!../../../nls/objectStorageConfig',
        'underscore',
        'jquery'
    ],
    function (
        BaseItemView,
        bucketSpecifyConfigurationTmpl,
        awsHelper,
        Events,
        messageBundle,
        _,
        $
    ) {
        'use strict';
        return  BaseItemView.extend({
            template: bucketSpecifyConfigurationTmpl,
            bucketList: [],
            ui: {
                bucketOption: 'input:radio[name=bucketOption]',
                bucketSelected: '#bucketOptionSelected',
                bucketNotSelected: '#bucketOptionNotSelected',
                bucketDropdown: '#add-storage-bucket',

                bucketListEmptyMessage: '#empty-bucket-list',
                bucketListDiv: '#bucketListDiv',

                noBucketDiv: '#noBucketDiv',

                bucketLabel: 'label.bucket-label',

                bucketInConfigurationText: '.bucket-in-configuration',
                specifyDirectoryLinkDiv: '#specifyDirectoryLinkDiv',
                specifyDirectoryLink: '#specify-directory-link',
                directoryDiv: '#directoryDiv',
                directoryPrefixField: '#directory-prefix',
                directoryPrefixWrapper: '#directory-prefix-wrapper',
                directoryPrefixIcon: '#directory-prefix-icon',

                filePrefixMessageArea: '.file-prefix-message-area',
                filePrefixMessage: '#file-prefix-message',
                encryptionOption: '.encryption',
                enableServerSideEncryptionCheckbox: '#enable-server-side-encryption'
            },

            events: {
                'click @ui.bucketInConfigurationText': 'clickBucketInConfigurationText',
                'focus @ui.bucketDropdown': 'handleFocusOnBucketDropdown',
                'click @ui.specifyDirectoryLink': 'showDirectoryPrefixField',
                'click @ui.bucketSelected': 'handleBucketSelected',
                'click @ui.bucketNotSelected': 'hideDirectoryPrefixOptions'
            },

            initialize: function (options) {
                if (options.bucketList) {
                    this.bucketList = options.bucketList;
                }
            },

            onShow: function () {
                this.hideBucketOptionsAndDisableAddCloudStorageButton();
            },

            showBucketSpecifyConfigurationOption: function () {
                this.unHideNoBucketDiv();
                if(this.bucketList.length > 0) {
                    this.unHideBucketListDiv();
                    this.populateBucketListDropdown(this.bucketList);
                }
            },

            showBucketSpecifyConfigurationOptions: function () {
                this.unHideNoBucketDiv();
                this.ui.bucketLabel.removeClass('hidden');

                if(this.bucketList.length > 0) {
                    this.unHideBucketListDiv();
                    this.populateBucketListDropdown(this.bucketList);
                    this.showDirectoryPrefixLink();
                    this.ui.bucketSelected.prop('checked', true);
                } else {
                    this.unHideNoBucketDiv();
                    this.ui.bucketNotSelected.prop('checked', true);
                }

                this.showEncryptionOption();
            },

            validateAWSBucketPrefix: function () {
                this.clearDirectoryPrefixErrors();
                var isPrefixLengthAcceptable = false;
                var isValidBucketPrefix = false;
                var directoryPrefixFieldVal = this.ui.directoryPrefixField.val().trim();

                if (awsHelper.isAWSStoragePrefixLengthAcceptable(directoryPrefixFieldVal)) {
                    isPrefixLengthAcceptable = true;
                    if (awsHelper.isValidAWSBucketPrefix(directoryPrefixFieldVal)) {
                        isValidBucketPrefix = true;
                    }
                }

                if (!(isPrefixLengthAcceptable && isValidBucketPrefix)) {
                    // mark with an "empty" message
                    this.showBucketPrefixErrorMessage(isPrefixLengthAcceptable);
                }

                return isPrefixLengthAcceptable && isValidBucketPrefix;
            },

            showBucketPrefixErrorMessage: function (isPrefixLengthAcceptable) {
                var errorMessage;
                if (!isPrefixLengthAcceptable) {
                    errorMessage = messageBundle.storage.addPanel.notValidStoragePrefixLength;
                } else {
                    errorMessage = messageBundle.storage.addPanel.notValidFilePrefix;
                }

                this.ui.filePrefixMessageArea.removeClass('hidden');
                this.markErrorField(this.ui.directoryPrefixWrapper);
                this.showError(this.ui.filePrefixMessage, errorMessage);
                this.ui.directoryPrefixIcon.show();
            },

            clearErrors: function () {
                this.clearDirectoryPrefixErrors();
            },

            clearDirectoryPrefixErrors: function () {
                this.clearErrorField(this.ui.directoryPrefixWrapper);
                this.ui.filePrefixMessage.text('');
                this.ui.directoryPrefixIcon.hide();
            },

            populateBucketListDropdown: function (bucketsList) {
                this.ui.bucketDropdown.empty();
                _.each(bucketsList, function (val) {
                    this.ui.bucketDropdown.append($('<option></option>').val(val).html(val));
                }, this);
            },

            isNoBucketSelected : function () {
                return this.ui.bucketNotSelected.is(':checked');
            },

            hideBucketOptionsAndDisableAddCloudStorageButton: function () {
                //this.disableAddCloudStorageButton();
                this.hideBucketListDiv();
                this.hideNoBucketDiv();
                this.hideDirectoryPrefixLinkDiv();
                this.hideDirectoryPrefixDiv();
                this.hideEncryptionOption();

                this.ui.bucketNotSelected.prop('checked', true);
                this.ui.bucketLabel.addClass('hidden');
            },

            setConfigurationValues: function (model) {
                // Make sure to unset the bucket and directory specified attribute in case the first save fails, and then
                // the second save has no bucket name / directory in the field
                if (this.isNoBucketSelected()) {
                    model.unset('bucket');
                    model.unset('filePrefix');
                } else if (!_.isEmpty(this.ui.bucketDropdown.val())) {
                    model.set('bucket', this.ui.bucketDropdown.val().trim());
                    if (!_.isEmpty(this.ui.directoryPrefixField.val().trim())) {
                        model.set('filePrefix', this.ui.directoryPrefixField.val().trim());
                    }
                }

                model.set('enableServerSideEncryption', this.ui.enableServerSideEncryptionCheckbox.is(':checked'));
            },

            show: function (bucketList) {
                this.bucketList = bucketList;
                this.hideBucketOptionsAndDisableAddCloudStorageButton();
                this.showBucketSpecifyConfigurationOptions();
            },

            disableAddCloudStorageButton: function () {
                this.ui.confirmAddStorage.attr('disabled', 'disabled');
            },

            enableAddCloudStorageButton: function () {
                this.ui.confirmAddStorage.removeAttr('disabled');
            },

            hideBucketListDiv: function () {
                this.ui.bucketListDiv.hide();
            },

            unHideBucketListDiv: function () {
                this.ui.bucketListDiv.show();
            },

            hideNoBucketDiv: function () {
                this.ui.noBucketDiv.hide();
            },

            unHideNoBucketDiv: function () {
                this.ui.noBucketDiv.show();
            },

            handleFocusOnBucketDropdown: function () {
                this.ui.bucketSelected.prop('checked', true);
                //this.unHideDirectoryPrefixLinkDiv();
                this.showDirectoryPrefixLink();
            },

            clickBucketInConfigurationText: function () {
                this.ui.bucketNotSelected.prop('checked', true);
                this.hideDirectoryPrefixOptions();
            },

            hideDirectoryPrefixLinkDiv: function () {
                this.ui.specifyDirectoryLinkDiv.hide();
            },

            hideDirectoryPrefixDiv: function () {
                this.clearDirectoryPrefixErrors();
                this.ui.directoryPrefixField.val('');
                this.ui.directoryDiv.hide();
            },

            unHideDirectoryPrefixDiv: function () {
                this.ui.directoryDiv.show();
            },

            handleBucketSelected: function () {
                this.showDirectoryPrefixLink();
            },

            showDirectoryPrefixLink: function () {
                if (this.ui.directoryDiv.css('display') === 'none') {
                    this.ui.specifyDirectoryLinkDiv.show();
                }
            },

            showDirectoryPrefixField: function (e) {
                e.preventDefault();
                this.ui.directoryPrefixField.val('');
                this.hideDirectoryPrefixLinkDiv();
                this.unHideDirectoryPrefixDiv();
            },

            hideDirectoryPrefixOptions: function () {
                this.clearDirectoryPrefixErrors();
                this.hideDirectoryPrefixLinkDiv();
                this.hideDirectoryPrefixDiv();
                this.ui.filePrefixMessageArea.addClass('hidden');
            },

            showEncryptionOption: function () {
                this.ui.encryptionOption.show();
            },

            hideEncryptionOption: function () {
                this.ui.encryptionOption.hide();
            }
        });
    });

